/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Claimant_Vehicle_DescriptionInputs */

const en_case_section_claimant_vehicle_description = /** @type {(inputs: Case_Section_Claimant_Vehicle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The vehicle Recobra is recovering value for.`)
};

const pt_br2_case_section_claimant_vehicle_description = /** @type {(inputs: Case_Section_Claimant_Vehicle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O veículo pelo qual a Recobra está recuperando o valor.`)
};

/**
* | output |
* | --- |
* | "The vehicle Recobra is recovering value for." |
*
* @param {Case_Section_Claimant_Vehicle_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_claimant_vehicle_description = /** @type {((inputs?: Case_Section_Claimant_Vehicle_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Claimant_Vehicle_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_claimant_vehicle_description(inputs)
	return pt_br2_case_section_claimant_vehicle_description(inputs)
});